var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepCheckShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 118,
    viewBox: "0 0 99 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5488 13.9632L50.4889 0.145175C49.8447 -0.0483918 49.1569 -0.0483918 48.512 0.145175L2.4517 13.9632C0.996505 14.3997 0 15.739 0 17.2582V67.9242C0 74.5142 2.66774 81.2602 7.92915 87.9747C11.9477 93.1029 17.5071 98.2523 24.453 103.28C36.1214 111.727 47.6111 116.908 48.0946 117.124C48.5418 117.324 49.0209 117.425 49.5002 117.425C49.9793 117.425 50.4587 117.325 50.9059 117.124C51.3893 116.908 62.8788 111.727 74.5472 103.28C81.4929 98.2523 87.0523 93.1029 91.0709 87.9747C96.3323 81.2604 99 74.5144 99 67.9242V17.2582C99.0002 15.739 98.004 14.3997 96.5488 13.9632ZM92.1199 67.9242C92.1199 79.5869 80.418 90.5225 70.6013 97.643C61.8005 104.026 52.875 108.556 49.5005 110.183C46.1259 108.556 37.2002 104.026 28.3993 97.643C18.5825 90.5225 6.88035 79.5869 6.88035 67.9242V19.8177L49.5002 7.03172L92.1199 19.8177V67.9242V67.9242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.383 24.9698C84.2886 24.6792 84.0375 24.4675 83.7352 24.4236L75.2439 23.1896L71.4464 15.4951C71.3112 15.2212 71.0323 15.0479 70.7268 15.0479C70.4214 15.0479 70.1424 15.2212 70.0072 15.4951L66.2095 23.1896L57.7183 24.4236C57.4161 24.4675 57.1649 24.6792 57.0706 24.9696C56.9761 25.2602 57.0549 25.5792 57.2736 25.7923L63.4177 31.7817L61.9675 40.2387C61.9159 40.5399 62.0397 40.8441 62.2868 41.0237C62.5339 41.2031 62.8614 41.2269 63.1319 41.0847L70.7267 37.0917L78.3214 41.0846C78.4388 41.1464 78.567 41.1768 78.6947 41.1768C78.8611 41.1768 79.0267 41.1252 79.1665 41.0237C79.4136 40.8441 79.5374 40.5398 79.4858 40.2387L78.0351 31.7817L84.1799 25.7923C84.3986 25.5791 84.4774 25.2602 84.383 24.9698Z",
    fill: "#FED42D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3832 24.9698C84.2889 24.6792 84.0377 24.4675 83.7355 24.4236L75.2442 23.1896L71.4467 15.4951C71.3115 15.2212 71.0325 15.0479 70.7271 15.0479V37.0918L78.3217 41.0847C78.4391 41.1464 78.5673 41.1769 78.6951 41.1769C78.8614 41.1769 79.0271 41.1252 79.1668 41.0237C79.4139 40.8441 79.5377 40.5398 79.4861 40.2388L78.0354 31.7817L84.1802 25.7923C84.3989 25.5791 84.4777 25.2602 84.3832 24.9698Z",
    fill: "#FCBF29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0358 52.9668H45.6883C43.6678 52.9668 42.0146 54.62 42.0146 56.6405V84.1934C42.0146 84.8669 42.5657 85.418 43.2392 85.418H55.4849C56.1584 85.418 56.7094 84.8669 56.7094 84.1934V56.6405C56.7095 54.62 55.0563 52.9668 53.0358 52.9668ZM54.2604 82.9688H44.4637V56.6405C44.4637 55.967 45.0147 55.416 45.6882 55.416H53.0357C53.7092 55.416 54.2603 55.967 54.2603 56.6405V82.9688H54.2604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3357 48.0688H66.9881C64.9676 48.0688 63.3145 49.722 63.3145 51.7425V84.1938C63.3145 84.8673 63.8655 85.4184 64.539 85.4184H76.7847C77.4582 85.4184 78.0092 84.8673 78.0092 84.1938V51.7425C78.0093 49.722 76.3562 48.0688 74.3357 48.0688ZM75.5602 82.9692H65.7635V51.7425C65.7635 51.069 66.3145 50.518 66.988 50.518H74.3355C75.009 50.518 75.5601 51.069 75.5601 51.7425L75.5602 82.9692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.1895,
    y: 49.6228,
    width: 11.2661,
    height: 34.9636,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.1177,
    y: 54.6733,
    width: 11.2661,
    height: 29.1363,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7717 62.7646H23.4242C21.4037 62.7646 19.7505 64.4178 19.7505 66.4383V84.1947C19.7505 84.8682 20.3015 85.4192 20.975 85.4192H33.2207C33.8942 85.4192 34.4453 84.8682 34.4453 84.1947V66.4385C34.4454 64.4178 32.7923 62.7646 30.7717 62.7646ZM31.9963 82.9701H22.1997V66.4385C22.1997 65.765 22.7507 65.2139 23.4242 65.2139H30.7717C31.4452 65.2139 31.9962 65.765 31.9962 66.4385V82.9701H31.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6929 63.9968H32.9589V84.198H21.6929V63.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_372_826",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4399 46.5928C20.4399 45.52 21.3096 44.6504 22.3824 44.6504H32.0945C33.1672 44.6504 34.0369 45.52 34.0369 46.5928V56.3049C34.0369 57.3777 33.1672 58.2474 32.0945 58.2474H22.3824C21.3096 58.2474 20.4399 57.3777 20.4399 56.3049V46.5928Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4399 46.5928C20.4399 45.52 21.3096 44.6504 22.3824 44.6504H32.0945C33.1672 44.6504 34.0369 45.52 34.0369 46.5928V56.3049C34.0369 57.3777 33.1672 58.2474 32.0945 58.2474H22.3824C21.3096 58.2474 20.4399 57.3777 20.4399 56.3049V46.5928Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-12-inside-1_372_826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7134 51.9833L26.413 53.683L30.2978 49.3125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-2_372_826",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5635 34.8606C42.5635 33.7879 43.4331 32.9182 44.5059 32.9182H54.218C55.2908 32.9182 56.1604 33.7879 56.1604 34.8606V44.5727C56.1604 45.6455 55.2908 46.5152 54.218 46.5152H44.5059C43.4331 46.5152 42.5635 45.6455 42.5635 44.5727V34.8606Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.5635 34.8606C42.5635 33.7879 43.4331 32.9182 44.5059 32.9182H54.218C55.2908 32.9182 56.1604 33.7879 56.1604 34.8606V44.5727C56.1604 45.6455 55.2908 46.5152 54.218 46.5152H44.5059C43.4331 46.5152 42.5635 45.6455 42.5635 44.5727V34.8606Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-14-inside-2_372_826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8369 40.2512L48.5365 41.9508L52.4214 37.5803",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1566,
    fill: "white",
    transform: "translate(-18 -147)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepCheckShield);
export default __webpack_public_path__ + "static/media/PrepCheckShield.6337938f880fbf1c7178b9519b767eb1.svg";
export { ForwardRef as ReactComponent };